import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, OtherWorkEvent, OtherWorkEventWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateOtherWorkEvent(): UseMutationResult<
  AxiosResponse<OtherWorkEvent>,
  AxiosError<ErrorMessage>,
  OtherWorkEventWrite
> {
  const queryClient = useQueryClient();

  const updateOtherWorkEvent = useCallback(
    (otherWorkEvent: OtherWorkEventWrite): Promise<AxiosResponse<OtherWorkEvent>> => {
      return client.put(`other-work-events/${otherWorkEvent.otherWorkEventId}/`, otherWorkEvent);
    },
    [],
  );

  return useMutation(updateOtherWorkEvent, {
    onSuccess: () => {
      queryClient.invalidateQueries('otherWorkEvents');
      queryClient.invalidateQueries('payrollEvents');
      queryClient.invalidateQueries('payrollPeriods');
      queryClient.invalidateQueries({
        queryKey: ['staffsPayout'],
      });
    },
  });
}
